import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from "react-redux";
import CONST from "../../config/CONST";
import breakpoints from "../../config/breakpoints";
import {getAppConfig, getAppData, getIsFormLayerVisible, setIsFormLayerVisible} from "../../store/slices/appSlice";
import ResizeObserver from 'react-resize-observer';
import UserConfiguration from "../UserConfiguration/UserConfiguration";
import Result from  "../Result/Result";
import DebugTable from "../DebugTable/DebugTable";
import CloseBtn from "../CloseBtn/CloseBtn";
import {useTranslation} from "react-i18next";
import FormLayer from "../FormLayer/FormLayer";
import numberFormat from "../../helpers/numberFormat";
import VehicleDetails from "../VehicleDetails/VehicleDetails";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import FormLayerOpenCta from "../FormLayerOpenCta/FormLayerOpenCta";
import Disclaimer from "../Disclaimer/Disclaimer";
import TotalServices from "../TotalServices/TotalServices";
import {logInfo} from "../../helpers/debugLog";

const Widget = (props) => {

    const {
        viewmode,
        closeBtn,
        closeBtnCallback
    } = props;

    const { t } = useTranslation();
    const appConfig = useSelector(getAppConfig);
    const appData = useSelector(getAppData);
    const financialProductConfiguration = useSelector(getFinancialConfiguration);
    const isFormLayerVisible = useSelector(getIsFormLayerVisible);

    const dispatch = useDispatch();

    const [breakpoint, setBreakpoint] = useState('bp-md');

    const [height, setHeight] = useState('100vh');

    const onResize = ({width}) => {

        logInfo("onResize", width);

        /* eslint-disable */
        const BreakException = {};
        try {
            Object.keys(breakpoints).forEach((bp) => {
                let minWidth = breakpoints[bp];
                if(width >= minWidth) {
                    if (breakpoint !== bp) {
                        setBreakpoint(bp);
                        //logInfo("Change breakpoint:", bp);
                    }
                    throw BreakException;
                }
            });
        } catch (e) {
            if (e !== BreakException) throw e;
        }
        /* eslint-enable */

    }

    const onPosition = ({top, left}) => {
        //logInfo("Widget position:", top, left);
    }

    useEffect(() => {
        const widgetCopies = document.getElementsByClassName(CONST.DOM_APP_WIDGET_ID);

        if(widgetCopies.length > 1) {
            for(let i = 1; i < widgetCopies.length; i++) {
                widgetCopies[i].innerHTML = '';
                //widgetCopies[i].remove(); // @TODO nice to have
            }
        }

        // by default, do not show form layer
        dispatch(setIsFormLayerVisible(false));
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if(!isFormLayerVisible) {
            setHeight('100vh');
        }
    }, [isFormLayerVisible]);

    const onFormLayerHeightChange = (h) => {
        if(h) {
            setHeight(h + 'px');
        }
        else {
            setHeight('100vh');
        }
    }

    // WORKAROUND FOR NISSAN INTEGRATION ONLY!!!
    useEffect(() => {

        const windowWidth = window.innerWidth;
        if(windowWidth >= 738 && windowWidth < 960) {
            onResize({
                width: windowWidth
            });
        }
        else if(windowWidth >= 960) {
            onResize({
                width: 960
            });
        }

        // eslint-disable-next-line
    }, []);

    if(!appConfig || !appData || !appData.input) {
        return null;
    }

    return (
        <div
            id={CONST.DOM_APP_WIDGET_ID}
            className={`
                ${CONST.DOM_APP_WIDGET_ID}
                ${CONST.CSS_NAMESPACE}theme-${appConfig.theme}
                ${CONST.CSS_NAMESPACE}viewmode-${viewmode}
                ${CONST.CSS_NAMESPACE}bp-${breakpoint}
            `}
            style={{
                height: height
            }}
        >
            <ResizeObserver
                onResize={onResize}
                onPosition={onPosition}
            />

            {/*{ (viewmode === CONST.VIEWMODE_STANDALONE && closeBtn === true) && <CloseBtn/> }*/}
            { (closeBtn === true) && <CloseBtn callback={closeBtnCallback} /> }


                <div className={`${CONST.CSS_NAMESPACE}WidgetMainContainer ${isFormLayerVisible ? `${CONST.CSS_NAMESPACE}WidgetMainContainerIsFormLayerVisible` : ``}`}>
                    <div className={`${CONST.CSS_NAMESPACE}row`}>
                        <h1 className={`${CONST.CSS_NAMESPACE}FinancialCalculation-title`}>{t(`FinancialSimulator`)}</h1>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-12 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <div className={`${CONST.CSS_NAMESPACE}UserConfigurationVehicleDetails`}>
                                <VehicleDetails
                                    financialProductConfiguration={financialProductConfiguration}
                                    price={appData.input.price}
                                    formatValue={value => `${appData.config.marketConfig.currencySymbol} ${numberFormat(value, appData.config.marketConfig.decimalPlaces, appData.config.marketConfig.decimalSeparator, appData.config.marketConfig.thousandsSeparator, false)}`}
                                    cashPriceDisclaimer= {t(`VATDisclaimer_${financialProductConfiguration?.selectedCustomer}`)}
                                    isVehiclePriceVisible={true}
                                />
                            </div>
                        </div>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-6 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <UserConfiguration/>

                        </div>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-6 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <Result
                                viewmode={viewmode}
                            />
                        </div>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-12 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <TotalServices
                                viewmode={viewmode}
                            />
                        </div>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-12 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <Disclaimer
                                viewmode={viewmode}
                            />
                        </div>
                        <DebugTable/>
                    </div>

                    <FormLayer
                        isVisible={isFormLayerVisible}
                        onFormLayerHeightChange={onFormLayerHeightChange}
                    />
                </div>

                <FormLayerOpenCta />



        </div>
    );
}

Widget.propTypes = {
    viewmode: PropTypes.string,
    closeBtn: PropTypes.bool,
    closeBtnCallback: PropTypes.func
}

export default Widget;